/** Full-viewport hub backdrop: full-bleed streaks video; static WebP/PNG only for `prefers-reduced-motion`. */
export const HUB_BACKDROP = {
  poster: '/assets/videos/Background_streaks-hub-poster.webp',
  videoMp41280: '/assets/videos/Background_streaks-hub-1280.mp4',
  videoMp41920: '/assets/videos/Background_streaks-hub-1920.mp4',
  png: '/assets/images/Neevii_Landing_Dark_Grey_BG.png',
  webp1280: '/assets/images/Neevii_Landing_Dark_Grey_BG-1280.webp',
  /** @deprecated Prefer webp3480 for desktop hub backdrop; kept for tooling / fallbacks. */
  webp1920: '/assets/images/Neevii_Landing_Dark_Grey_BG-1920.webp',
  /** Desktop / wide viewports (>1024px) — still fallback when motion is reduced. */
  webp3480: '/assets/images/Neevii_Landing_Dark_Grey_BG-3480.webp',
};

/** @deprecated use `HUB_BACKDROP.png` (static) or `HUB_BACKDROP.videoMp41920` (video) */
export const HUB_BACKDROP_SRC = HUB_BACKDROP.png;

function hubCardThumb(stem) {
  const base = `/assets/images/${stem}`;
  return {
    thumbSrc: `${base}.png`,
    thumbWebpSrcSet: `${base}-640.webp 640w, ${base}-1024.webp 1024w, ${base}-1536.webp 1536w`,
  };
}

/** Minimal hub header + cards share the same destinations. */
export function getHubNavItems() {
  return [
    {
      key: 'accounting',
      label: 'Neevii Accounting app',
      external: false,
      path: '/accounting',
    },
    {
      key: 'sheets',
      label: 'Neevii Smart Expenses',
      external: false,
      path: '/sheets',
    },
    {
      key: 'agency',
      label: 'Agency Partnerships',
      external: false,
      path: '/agency',
    },
  ];
}

/** Same titles as legacy `Header` on the Neevii Accounting marketing page. */
export function getAccountingMarketingHeaderLinks() {
  return [
    { key: 'home', label: 'Home', path: '/' },
    { key: 'charity', label: 'Charities', path: '/charity' },
    { key: 'pricing', label: 'Pricing', path: '/subscription' },
    { key: 'sheets', label: 'Neevii sheets sidebar', path: '/sheets' },
    { key: 'updates', label: 'New Features', path: '/updates' },
    { key: 'tutorials', label: 'Tutorials', path: '/tutorials' },
    { key: 'faq', label: 'FAQ', path: '/faq' },
  ];
}

/** Same titles as legacy sheets-shell `Header` on Smart Expenses marketing pages. */
export function getSheetsMarketingHeaderLinks() {
  return [
    { key: 'home', label: 'Home', path: '/' },
    { key: 'accounting', label: 'Neevii Accounting app', path: '/accounting' },
    { key: 'agency', label: 'Agency Partnerships', path: '/agency' },
  ];
}

export function getHubCards() {
  return [
    {
      key: 'accounting',
      title: 'Neevii Accounting',
      description: 'AI accounting, invoicing, and HMRC-ready workflows for UK small businesses.',
      ...hubCardThumb('Neevii_card_thumb_card'),
      ctaLabel: 'Go to Accounting app',
      ctaTheme: 'accounting',
      path: '/accounting',
      external: false,
    },
    {
      key: 'sheets',
      title: 'Neevii Smart Expenses',
      description: 'Google Sheets sidebar: scan receipts and map spend into tax-ready categories.',
      ...hubCardThumb('Neevii_Smart_Expenses_thumb_card'),
      ctaLabel: 'Go to Sheets Sidebar',
      ctaTheme: 'sheets',
      path: '/sheets',
      external: false,
    },
    {
      key: 'agency',
      title: 'Agency Partnerships',
      description: 'Design-led portals, dashboards & workflow systems for your clients.',
      ...hubCardThumb('Neevii_Partner_thumb_card'),
      ctaLabel: 'Explore partnerships',
      ctaTheme: 'agency',
      path: '/agency',
      external: false,
    },
  ];
}
